import { ApiKeysServiceInterface } from 'domain/services';
import {
  CreateApiKeyUseCaseInterface,
  ListApiKeysUseCaseInterface,
  ToggleApiKeyUseCaseInterface,
  UpdateNameApiKeyUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  listApiKeys: ListApiKeysUseCaseInterface;
  createApiKey: CreateApiKeyUseCaseInterface;
  updateApiKeyName: UpdateNameApiKeyUseCaseInterface;
  toggleApiKey: ToggleApiKeyUseCaseInterface;
}

export class ApiKeysService implements ApiKeysServiceInterface {
  private readonly _listApiKeys: ListApiKeysUseCaseInterface;
  private readonly _createApiKey: CreateApiKeyUseCaseInterface;
  private readonly _updateApiKeyName: UpdateNameApiKeyUseCaseInterface;
  private readonly _toggleApiKey: ToggleApiKeyUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._listApiKeys = usecases.listApiKeys;
    this._createApiKey = usecases.createApiKey;
    this._updateApiKeyName = usecases.updateApiKeyName;
    this._toggleApiKey = usecases.toggleApiKey;
  }

  listApiKeys(): Promise<ListApiKeysUseCaseInterface.Result> {
    return this._listApiKeys.execute();
  }

  createApiKey(
    params: Parameters<CreateApiKeyUseCaseInterface['execute']>[0],
  ): Promise<CreateApiKeyUseCaseInterface.Result> {
    return this._createApiKey.execute(params);
  }

  updateApiKeyName(
    params: Parameters<UpdateNameApiKeyUseCaseInterface['execute']>[0],
  ): Promise<UpdateNameApiKeyUseCaseInterface.Result> {
    return this._updateApiKeyName.execute(params);
  }

  toggleApiKey(params: {
    id: string;
    active: boolean;
  }): Promise<ToggleApiKeyUseCaseInterface.Result> {
    return this._toggleApiKey.execute(params);
  }
}
